import React from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RadioInputProps } from "./types";

export default function RadioInput(props: RadioInputProps) {
	const {
		id,
		type = "radio",
		name,
		label,
		wrapperClassname,
		inputClassName,
		labelClassname,
		iconClass,
		...rest
	} = props;

	const { t } = useTranslation();
	const form = useFormContext();

	const field = form.register(props.name, {
		required: {
			value: props.required || false,
			message: props.errorMessage || "COMMON.REQUIRED_FIELD",
		},
		disabled: props.disabled,
	});

	return (
		<div className={classNames("input--radio", wrapperClassname)}>
			<input
				id={id}
				type={type}
				className={classNames("input--radio__box", inputClassName)}
				{...rest}
				{...field}
			/>
			<label
				htmlFor={id}
				className={classNames("input--radio__label", labelClassname)}
			>
				{iconClass && <i className={classNames(iconClass)} />}
				<span className="u-align--v--middle">{t(label)}</span>
			</label>
		</div>
	);
}
